import {OutsideClickClass} from "../module/outside-click.class";

export class DropdownClass {
    private readonly dropdownSelector = '.js-dropdown';
    private readonly dropdownToggleSelector = '.js-dropdown-toggle'
    private readonly stateClass = 'is-active';

    private dropdownElements: HTMLElement[];

    constructor() {
        this.dropdownElements = Array.from(document.querySelectorAll(this.dropdownSelector));
        if (this.dropdownElements.length > 0) {
            this.listen();
        }
    }

    listen(): void {
        this.dropdownElements.forEach(dropdownEl => {
            dropdownEl
                .querySelector(this.dropdownToggleSelector)
                .addEventListener('click', (e: Event) => this.onClickDropdown(e));
        })
    }

    /**
     * Click on dropdown element : toggle CSS class to show/hide dropdown list
     * @param e
     * @private
     */
    private onClickDropdown(e: Event): void {
        const toggleElem: HTMLButtonElement = e.currentTarget as HTMLButtonElement
        const dropdownElem: HTMLElement = toggleElem.closest(this.dropdownSelector) as HTMLElement;
        dropdownElem.classList.toggle(this.stateClass);

        OutsideClickClass.addElement(this.dropdownSelector, () => {
            this.closeDropdown(dropdownElem);
        })

    }

    private closeDropdown(el: HTMLElement) {
        el.classList.remove(this.stateClass);
    }
}
